export const AuthMethodEnum = {
  CREDENTIALS: "CREDENTIALS",
  OKTA: "OKTA",
  MIDWAY: "MIDWAY",
  AUTH_CODE: "AUTH_CODE",
};
